import React, { useEffect } from "react";
import { HeaderImgSection } from '../../Header/HeaderImgSection'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import slider from '../../../images/SOCIAL MEDIA MARKETING/SOCIAL-MEDIA-MARKETING-1900-220.png'
import sidebar from '../../../images/SOCIAL MEDIA MARKETING/SOCIAL-MEDIA-MARKETING.png'

function SocialMediaMarketing() {
  useEffect(() => {
    document.title = "Social Media Marketing || OZVASERVICE"
 }, []);
  return (
    <>
      <HeaderImgSection img={slider} hTitle={'Services'} title={"Social Media Marketing"}></HeaderImgSection>
      <Container className='my-5'>
        <h1 className='text-center text-primary fw-semibold '>Social Media Marketing</h1>
        <p className='text-center'>At OZVA SERVICE, we amplify your brand’s online presence by building authentic, lasting connections with your audience through powerful and personalized social media strategies. Our goal is simple — to help you grow, engage, and convert — transforming passive followers into loyal customers.</p>
        <p className='text-center'>We begin with a deep dive into your business objectives, audience behavior, and current market trends. With these insights, we craft a customized social media marketing strategy that aligns with your brand voice, goals, and vision — ultimately maximizing your return on investment (ROI).</p>

        <Row className='my-5 align-items-center'>
          <Col lg={6} className='mb-lg-0 mb-3'>
            <h2 className='text-dark fw-semibold'>Social Media Marketing Services That Drive Results</h2>
            <p>Searching for a reliable, results-driven social media marketing agency? OZVA SERVICE delivers expert social media management tailored to enhance your brand’s visibility and boost engagement across platforms like Facebook, Instagram, LinkedIn, Twitter, and YouTube.</p>
            <p>In today’s digital world, social media is no longer optional — it's essential. With over 75% of internet users active on social platforms, overlooking it means missing valuable growth opportunities. Our team empowers your brand with engaging content, strategic scheduling, and high-performing ad campaigns to increase reach, drive traffic, and generate leads.</p>
            <p>Our approach strengthens brand storytelling, fosters meaningful engagement, and nurtures customer loyalty. From content creation and community management to campaign analytics and paid media — OZVA SERVICE is your strategic partner in social media success.</p>
              {/* <p>
              <span className='fw-semibold'>Ads in Business Development :</span> With so many potential clients around, social media marketing may be used as bait if done correctly. Our data-driven social media marketing services will help you maximise your ROI.
              </p> */}
          </Col>  
          <Col lg={6} className='d-flex justify-content-center align-items-center'>
            <div className="">
              <img src={sidebar} className='img-fluid rounded-2' alt="" />
            </div>
          </Col>
        </Row>

        <h2 className='fw-semibold mb-4'>The Benefits of Social Media Marketing:</h2>
        <ul>
          <li>Boost online visibility by partnering with a proven social media marketing agency.</li>
          <li>Expand your reach across top platforms to increase qualified leads and customer acquisition.</li>
          <li>Drive engagement through more likes, shares, comments, and conversations.</li>
          <li>Build brand awareness and stay top-of-mind in a competitive market.</li>
          <li>Turn followers into loyal customers with tailored content and smart targeting.</li>
          <li>Increase website traffic through compelling, click-worthy campaigns</li>
          <li> Foster trust and loyalty by building authentic connections with your audience.</li>
        </ul>
       
      </Container>
    </>
  )
}
export default SocialMediaMarketing
